import dagre from 'dagre';

// Layout constants
export const NODE_DIMENSIONS = {
  width: 250,  // Increased width
  height: 60,  // Increased height
};

// Dagre graph configuration
const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

export const getLayoutedElements = (nodes, edges, direction = 'TB') => {
  dagreGraph.setGraph({ 
    rankdir: direction,
    nodesep: 150,  // Increased spacing between nodes in same rank
    ranksep: 200,  // Increased spacing between ranks
    edgesep: 120,  // Increased edge spacing
    marginx: 50,   // Added margin
    marginy: 50,   // Added margin
  });

  // Clear the graph before laying out
  dagreGraph.nodes().forEach(node => dagreGraph.removeNode(node));

  // Add nodes to the graph
  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, { width: NODE_DIMENSIONS.width, height: NODE_DIMENSIONS.height });
  });

  // Add edges to the graph
  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  // Apply the layout
  dagre.layout(dagreGraph);

  // Get the positioned nodes from dagre
  const layoutedNodes = nodes.map((node) => {
    const nodeWithPosition = dagreGraph.node(node.id);
    return {
      ...node,
      position: {
        x: nodeWithPosition.x - NODE_DIMENSIONS.width / 2,
        y: nodeWithPosition.y - NODE_DIMENSIONS.height / 2,
      },
    };
  });

  return { nodes: layoutedNodes, edges };
}; 